import { apiClient } from "./api";

/** Facet 通知对象（对齐后端 /api/v1/notifications 响应）。 */
export interface NotificationItem {
  id: string;
  tenant_id?: string;
  user_id?: string;
  type: string;
  title: string;
  content: string;
  link?: string;
  is_read: boolean;
  read_at?: string | null;
  created_at: string;
}

export interface SendNotificationPayload {
  tenant_id: string;
  user_id?: string;
  type?: string;
  title: string;
  content: string;
  link?: string;
}

/** 拉取当前用户通知（最新在前，后端经 Facet 截断为 100 条）。 */
export async function listNotifications(unread?: boolean): Promise<NotificationItem[]> {
  const response = await apiClient.get<{ data: NotificationItem[] }>("/notifications", {
    params: unread === undefined ? {} : { unread },
  });
  return response.data.data;
}

/** 标记单条通知为已读。 */
export async function markNotificationRead(id: string): Promise<void> {
  await apiClient.post(`/notifications/${id}/read`);
}

/** 全部标记已读。 */
export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.post("/notifications/read-all");
}

/** 通过 Facet 控制台发送通知（best-effort；后端未配置控制台凭据时返回 501）。 */
export async function sendNotification(payload: SendNotificationPayload): Promise<NotificationItem> {
  const response = await apiClient.post<NotificationItem>("/notifications/send", payload);
  return response.data;
}
